import { Box, createStyles, Stack } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import type { TeamOut } from '@repo/api-codegen';
import { useState } from 'react';
import { InviteTeamMemberForm } from '../InviteTeamMemberForm/InviteTeamMemberForm';
import { TeamMembersList } from './TeamMembersList';

const useStyles = createStyles((theme) => ({
	searchContainer: {
		position: 'sticky',
		top: 0,
		zIndex: 1,
		paddingBottom: theme.spacing.md,
	},
	listContainer: {
		flex: 1,
		minHeight: 0,
		overflow: 'hidden',
	},
}));

export function TeamMembersTab({ team }: { team: TeamOut }) {
	const { classes } = useStyles();
	const [searchTerm, setSearchTerm] = useState('');
	const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 500);

	return (
		<Stack spacing={0} h="100%">
			<Box className={classes.searchContainer} style={{ paddingTop: 0 }}>
				<InviteTeamMemberForm
					team={team}
					searchValue={searchTerm}
					setSearchValue={setSearchTerm}
					placeholder="Search for or add new team members"
				/>
			</Box>
			<Box className={classes.listContainer}>
				<TeamMembersList team={team} searchTerm={debouncedSearchTerm} />
			</Box>
		</Stack>
	);
}
